import { Action } from 'redux';
import { Epic } from 'redux-observable';
import { EMPTY } from 'rxjs';

import { Observable } from '../../../node_modules/rxjs/Rx';
import { FETCH_GOALS_DATA, updateGoalsData } from '../../actions/goals';
import { EpicDeps } from '../../service/StoreFactory';
import { GoalsQuery } from '../../typings/graphql-grid';
import { State } from '../../typings/state';

export const fetchGoalsDataEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$, deps) => {
    return action$.ofType(FETCH_GOALS_DATA).switchMap(
        (): Observable<Action> => {
            const state = store$.value;

            const {
                goalsData: { goals },
                commonData: { login }
            } = state;

            if (!goals) {
                return Observable.fromPromise(deps.goalsDataProvider.fetchMetricsGoals(login))
                    .map((response: GoalsQuery) => {
                        const {
                            client: { campaignGoals }
                        } = response;

                        return updateGoalsData(
                            campaignGoals.rowset.reduce((acc, goal) => {
                                acc[String(goal.id)] = {
                                    id: String(goal.id),
                                    name: goal.name
                                };

                                return acc;
                            }, {})
                        );
                    })
                    .catch(() => EMPTY);
            }

            return Observable.empty();
        }
    );
};
